import type { VariantProps } from "class-variance-authority";

import { cva } from "class-variance-authority";
import * as React from "react";

import { cn } from "../utils/cn";

export const inputVariants = cva(
  "flex h-11 w-full rounded-sm border border-input bg-background px-3.5 py-2.5 text-sm shadow-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-0 focus-visible:outline-hidden disabled:cursor-not-allowed disabled:bg-muted disabled:text-muted-foreground",
);

interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement>, VariantProps<typeof inputVariants> {}

type InputChangeEvent = React.ChangeEvent<HTMLInputElement>;

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return <input type={type} className={cn(inputVariants(), className)} ref={ref} {...props} />;
  },
);
Input.displayName = "Input";

export { Input, type InputChangeEvent };
